import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiButton } from '@splashthat/sui';

import './styles.styl';

const DEFAULT_LABEL = 'Copy link';
const BASE_CLASS_NAME = 'ClipboardCopyButton';

class ClipboardCopyButton extends Component {
    static propTypes = {
        label: PropTypes.string,
        textToCopy: PropTypes.string.isRequired,
        className: PropTypes.string,
        buttonElement: PropTypes.node,
        onCopy: PropTypes.func,
    };

    static defaultProps = {
        className: '',
        label: DEFAULT_LABEL,
        onCopy: () => {},
        buttonElement: null,
    };

    constructor(props) {
        super(props);

        this.textarea = React.createRef();
    }

    onClick = () => {
        this.textarea.current.select();
        document.execCommand('copy');
        this.props.onCopy(this.props.textToCopy);
    };

    render() {
        return (
            <div className={`${BASE_CLASS_NAME} ${this.props.className}`}>
                {this.props.buttonElement ? (
                    React.cloneElement(this.props.buttonElement, {
                        onClick: this.onClick,
                    })
                ) : (
                    <SuiButton label={this.props.label} variation="text" onClick={this.onClick} />
                )}
                <textarea
                    ref={this.textarea}
                    readOnly
                    className={`${BASE_CLASS_NAME}__hidden-input`}
                    value={this.props.textToCopy}
                />
            </div>
        );
    }
}

export default ClipboardCopyButton;
